import { Injectable, signal, computed } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root' // Das macht den Service zu einem anwendungsweiten Singleton
})
export class PGFilterService {

  public PG = signal<number>(-1);

  public dataChanged = this.PG.asReadonly();
  public dataChanged$: Observable<number> = toObservable(this.PG);

  constructor() {
    const pg = sessionStorage.getItem('PG');

    if (pg && !isNaN(Number(pg))) {
      this.loadOrUpdateData(parseInt(pg));
    }
  }

  public loadOrUpdateData(newPG: number) {
    try {

      this.PG.set(newPG);
      sessionStorage.setItem("PG", newPG.toString());

    } catch (error) {
      console.log('Fehler beim Laden der Daten:', error);
      //throw error;
    }
  }

  /**
   * Falls du den Status manuell zurücksetzen willst
   */
  public resetStatus(): void {
    this.PG.set(-1);
  }
}
